import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import { NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";
import TxtRow from "components/Custom/TxtRow";

import { MASTER_APIs } from "apihandlers/master";
import AutoComplete from "components/Custom/AutoComplete";
import { GEO_APIs } from "apihandlers/geography";
import { USER_APIs } from "apihandlers/user";

const Game = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>();
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [countries, setCountries] = useState<any>([]);
  const [states, setStates] = useState<any>([]);
  const [centralZone, setCentralZone] = useState<any>([]);
  const [regions, setRegions] = useState<any>([]);
  const [regionZone, setRegionZone] = useState<any>([]);
  const [city, setCity] = useState<any>([]);
  const [districts, setDistricts] = useState<any>([]);
  const [gameProgress, setGameProgress] = useState<any>([]);
  const [executive, setExecutive] = useState<any>([]);
  const [dealer, setDealer] = useState<any>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [itemsRow, setItemRow] = useState<any>(
    selectedRow.items ? selectedRow.items : []
  );
  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "name",
      name: LABELS.NAME,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "detail",
      name: LABELS.DETAILS,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "country",
      name: LABELS.COUNTRY,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "city",
      name: LABELS.CITY,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "dealer",
      name: LABELS.DEALER,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: " executive",
      name: LABELS.EXECUTIVE,
      width: "15%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: " isDealer",
      name: LABELS.IS_DEALER,
      width: "15%",
      type: "dropdown",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
      filters: [
        {
          id: "yes",
          name: "YES",
        },
        {
          id: "no",
          name: "NO",
        },
      ],
    },
    {
      key: " isMarketingTeam",
      name: LABELS.IS_MARKETING_TEAM,
      width: "15%",
      type: "dropdown",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
      filters: [
        {
          id: "yes",
          name: "YES",
        },
        {
          id: "no",
          name: "NO",
        },
      ],
    },

    {
      key: "activeStatusText",
      name: LABELS.ACTIVE,
      width: "5%",
      type: "dropdown",
      filters: [
        { id: "yes", name: "Yes" },
        { id: "no", name: "No" },
      ],
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "options",
      name: "Options",
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];
  const itemsColumn = [
    {
      key: "fromDate",
      name: LABELS.FROM_DATE,
      width: "20%",
      type: "datetime",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "toDate",
      name: LABELS.TO_DATE,
      width: "20%",
      type: "datetime",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "salesLow",
      name: LABELS.SALES_LOW,
      width: "10%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "salesHigh",
      name: LABELS.SALES_HIGH,
      width: "10%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
    {
      key: "rewardType",
      name: LABELS.REWARD_TYPE,
      width: "20%",
      type: "text",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },

    {
      key: "isPercentage",
      name: LABELS.IS_PERCENTAGE,
      width: "20%",
      type: "dropdown",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
      list: [
        {
          id: "Yes",
          label: "YES",
        },
        {
          id: "No",
          label: "NO",
        },
      ],
    },
  ];

  const countriesRef: any = useRef(null);
  const stateRef: any = useRef(null);
  const centralZoneRef: any = useRef(null);
  const regionRef: any = useRef(null);
  const regionZoneRef: any = useRef(null);
  const cityRef: any = useRef(null);
  const districtRef: any = useRef(null);
  const gameProgressRef: any = useRef(null);
  const executiveRef: any = useRef(null);
  const dealerRef: any = useRef(null);
  const itemGridRef: any = useRef(null);

  useEffect(() => {
    getCountries();
  }, []);

  const getCountries = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getCountries(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.countryName,
          };
        });
        setCountries(list);
        getUsers();
      }
    });
  };

  const getCentralZones = async (countryId) => {
    let centralZoneList = [];
    try {
      const args = {
        countryId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getCentralZones(args);
      centralZoneList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.centralZoneName,
        };
      });
    } catch (error) {}
    return centralZoneList;
  };

  const getStates = async (countryZoneId) => {
    let stateList = [];
    try {
      const args = {
        countryZoneId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getStates(args);
      stateList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.stateName,
        };
      });
    } catch (error) {}
    return stateList;
  };

  const getDistricts = async (stateId) => {
    let districtList = [];
    try {
      const args = {
        stateId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getDistricts(args);
      districtList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.districtName,
        };
      });
    } catch (error) {}
    return districtList;
  };

  const getRegionZone = async (stateId) => {
    let regionZoneList = [];
    try {
      const args = {
        stateId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getRegionZones(args);
      regionZoneList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.regionZoneName,
        };
      });
    } catch (error) {}
    return regionZoneList;
  };

  const getRegion = async (districtId) => {
    let regionList = [];
    try {
      const args = {
        districtId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getRegions(args);
      regionList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.regionName,
        };
      });
    } catch (error) {}
    return regionList;
  };

  const getCities = async (regionId) => {
    let cityList = [];
    try {
      const args = {
        regionId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getCities(args);
      cityList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.cityName,
        };
      });
    } catch (error) {}
    return cityList;
  };

  const getUsers = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    USER_APIs.getUsers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setExecutive(list);
      }
      getBranchProfile();
    });
  };

  const getBranchProfile = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    MASTER_APIs.getBranchProfile(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.name,
          };
        });
        setDealer(list);
        getRows();
      }
    });
  };

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await MASTER_APIs.getGames(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
          if (list[i]["isDealer"]) {
            list[i]["isDealer"] = "Yes";
          } else {
            list[i]["isDealer"] = "No";
          }
          if (list[i]["isMarketingTeam"]) {
            list[i]["isMarketingTeam"] = "Yes";
          } else {
            list[i]["isMarketingTeam"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getCities:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    setItemRow(row.items);
    console.log(selectedRow);
  };

  const manageRecord = () => {
    const name = (
      document.getElementById("name") as HTMLInputElement
    ).value.trim();
    const detail = (
      document.getElementById("details") as HTMLInputElement
    ).value.trim();
    const fromDate = (
      document.getElementById("fromDate") as HTMLInputElement
    ).value.trim();
    const toDate = (
      document.getElementById("toDate") as HTMLInputElement
    ).value.trim();
    const countryId = countriesRef.current.selectedValue.id;
    const stateId = stateRef.current.selectedValue.id;
    const centralzoneId = centralZoneRef.current.selectedValue.id;
    const regionzoneId = regionZoneRef.current.selectedValue.id;
    const regionId = regionRef.current.selectedValue.id;
    const cityId = cityRef.current.selectedValue.id;
    const districtId = districtRef.current.selectedValue.id;
    const gameProgressId = gameProgressRef.current.selectedValue.id;
    const executiveId = executiveRef.current.selectedValue.id;
    const dealerId = dealerRef.current.selectedValue.id;
    const recordedOn = (
      document.getElementById("recordedOn") as HTMLInputElement
    ).value.trim();
    const value = (
      document.getElementById("value") as HTMLInputElement
    ).value.trim();
    const percentage = (
      document.getElementById("percentage") as HTMLInputElement
    ).value.trim();
    const maxValue = (
      document.getElementById("maxValue") as HTMLInputElement
    ).value.trim();

    let op = document.querySelector(
      'input[name="isDealer"]:checked'
    ) as HTMLInputElement;
    const isDealer = op ? op.value : "";
    let selected = document.querySelector(
      'input[name="isMarketingTeam"]:checked'
    ) as HTMLInputElement;
    const isMarketingTeam = selected ? selected.value : "";
    let active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = active ? active.value : "";
    //todo:Validations needs to be done

    // Validations
    let errors = [];
    if (name === "") {
      errors.push({
        id: "name",
        msg:
          "<span class='bold'>" +
          LABELS.DETAILS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (detail === "") {
      errors.push({
        id: "detail",
        msg:
          "<span class='bold'>" +
          LABELS.NAME +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (fromDate === "") {
      errors.push({
        id: "fromDate",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDate === "") {
      errors.push({
        id: "toDate",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      gameId: selectedRow.id || -1,
      name,
      detail,
      fromDate,
      toDate,
      countryId,
      stateId,
      centralzoneId,
      regionzoneId,
      regionId,
      cityId,
      districtId,
      gameProgressId,
      executiveId,
      dealerId,
      recordedOn,
      value,
      percentage,
      maxValue,
      isDealer,
      isMarketingTeam,
      activeStatus,
      items: itemGridRef.getRowData(),
    };
    console.log("args", args);
    setIsSubmit(true);
    MASTER_APIs.manageGame(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
    setItemRow([]);
  };

  const handleCountryChange = async (e, f) => {
    if (f.id) {
      const res = await getCentralZones(f.id);
      setCentralZone(res);
      setStates([]);
      setDistricts([]);
      setRegionZone([]);
      setRegions([]);
      setCity([]);
    }
  };

  const handleCentralZoneChange = async (e, f) => {
    if (f.id) {
      const res = await getStates(f.id);
      setStates(res);
      setDistricts([]);
      setRegionZone([]);
      setRegions([]);
      setCity([]);
    }
  };

  const handleStateChange = async (e, f) => {
    if (f.id) {
      const res = await getDistricts(f.id);
      setDistricts(res);
      setRegions([]);
      setCity([]);
    }
    if (f.id) {
      const res = await getRegionZone(f.id);
      setRegionZone(res);
    }
  };

  const handleDistrictChange = async (e, f) => {
    if (f.id) {
      const res = await getRegion(f.id);
      setRegions(res);
      setCity([]);
    }
  };

  const handleRegionChange = async (e, f) => {
    if (f.id) {
      const res = await getCities(f.id);
      setCity(res);
    }
  };

  const getDeaultItemRow = () => {
    const newRow: any = {
      id: "1." + (itemGridRef.getRowData().length + 1).toString(),
    };
    return newRow;
  };

  console.log("selectedRow", selectedRow);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.GAME}</li>
        </ul>
        <h4>{TITLES.GAME}</h4>
        <p>{SUB_TITLES.GAME}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={"game"}
            height={window.innerHeight * 0.8}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.GAME}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.GAME + ": " + selectedRow.assetName
              : "Add New " + LABELS.GAME
          }
          open={true}
          size={"md"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="flexRowJustify">
            <div className="formGroup width30 ">
              <TxtRow
                id={"name"}
                type={"text"}
                label={LABELS.NAME}
                required={true}
                defaultValue={selectedRow.name}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30 ">
              <TxtRow
                id={"details"}
                type={"text"}
                label={LABELS.DETAILS}
                required={true}
                defaultValue={selectedRow.details}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30 ">
              <TxtRow
                id={"fromDate"}
                type={"date"}
                label={LABELS.FROM_DATE}
                required={true}
                defaultValue={selectedRow.fromDate}
                disabled={isSubmit}
              />
            </div>
          </div>

          <div className="flexRowJustify">
            <div className="formGroup width30">
              <TxtRow
                id={"toDate"}
                type={"date"}
                label={LABELS.TO_DATE}
                required={true}
                defaultValue={selectedRow.toDate}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30 ">
              <label>
                {LABELS.COUNTRY}
                {/* <span className="red">{" *"}</span> */}
              </label>
              <AutoComplete
                list={countries}
                childRef={countriesRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.countryId,
                        label: selectedRow.countryName,
                      }
                    : null
                }
                disabled={isSubmit}
                onChange={handleCountryChange}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.CENTRAL_ZONE}</label>
              <AutoComplete
                list={centralZone}
                childRef={centralZoneRef}
                defaultValue={
                  selectedRow.centralZoneId
                    ? {
                        id: selectedRow.centralZoneId,
                        label: selectedRow.centralZoneName,
                      }
                    : null
                }
                disabled={isSubmit}
                onChange={handleCentralZoneChange}
              />
            </div>
          </div>

          <div className="flexRowJustify">
            <div className="formGroup width30">
              <label>
                {LABELS.STATE}
                {/* {<span>*</span>} */}
              </label>
              <AutoComplete
                list={states}
                childRef={stateRef}
                defaultValue={
                  selectedRow.stateId
                    ? {
                        id: selectedRow.stateId,
                        label: selectedRow.stateName,
                      }
                    : null
                }
                onChange={handleStateChange}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.DISTRICT}</label>
              <AutoComplete
                list={districts}
                childRef={districtRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.districtId,
                        label: selectedRow.districtName,
                      }
                    : null
                }
                onChange={handleDistrictChange}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <label>
                {LABELS.REGION_ZONE}
                {/* {<span>*</span>} */}
              </label>
              <AutoComplete
                list={regionZone}
                childRef={regionZoneRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.regionId,
                        label: selectedRow.regionName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
          </div>

          <div className="flexRowJustify">
            <div className="formGroup width30">
              <label>
                {LABELS.REGION}
                {/* {<span>*</span>} */}
              </label>
              <AutoComplete
                list={regions}
                childRef={regionRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.regionId,
                        label: selectedRow.regionName,
                      }
                    : null
                }
                onChange={handleRegionChange}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30 ">
              <label>{LABELS.CITY}</label>
              <AutoComplete
                list={city}
                childRef={cityRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.cityId,
                        label: selectedRow.cityName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.GAME_PROGRESS}</label>
              <AutoComplete
                list={gameProgress}
                childRef={gameProgressRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.districtId,
                        label: selectedRow.districtName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
          </div>

          <div className="flexRowJustify">
            <div className="formGroup width30">
              <label>{LABELS.EXECUTIVE}</label>
              <AutoComplete
                list={executive}
                childRef={executiveRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.executiveId,
                        label: selectedRow.executiveName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.DEALER}</label>
              <AutoComplete
                list={dealer}
                childRef={dealerRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.dealerId,
                        label: selectedRow.dealerName,
                      }
                    : null
                }
                onChange={(e, v) => {}}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <TxtRow
                id={"recordedOn"}
                type={"date"}
                label={LABELS.RECORDED_ON}
                defaultValue={selectedRow.recordedOn}
                disabled={isSubmit}
              />
            </div>
          </div>

          <div className="flexRowJustify">
            <div className="formGroup width30 ">
              <TxtRow
                id={"value"}
                type={"number"}
                label={LABELS.VALUE}
                defaultValue={selectedRow.value}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30 ">
              <TxtRow
                id={"percentage"}
                type={"number"}
                label={LABELS.PERCENTAGE}
                defaultValue={selectedRow.percentage}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30 ">
              <TxtRow
                id={"maxValue"}
                type={"number"}
                label={LABELS.MAX_VALUE}
                defaultValue={selectedRow.maxValue}
                disabled={isSubmit}
              />
            </div>
          </div>

          <div className="flexRowJustify">
            <div className="formGroup width30">
              <label>{LABELS.IS_DEALER}</label>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.YES,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === true
                      : true,
                    disabled: false,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.NO,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === false
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"isDealer"}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup width30">
              <label>{LABELS.IS_MARKETING_TEAM}</label>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.YES,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === true
                      : true,
                    disabled: false,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.NO,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === false
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"isMarketingTeam"}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup required width30 ">
              <label>{LABELS.ACTIVE_STATUS}</label>
              <span className="red">{" *"}</span>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.ACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === true
                      : true,
                    disabled: false,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.INACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === false
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                disabled={isSubmit}
              />
            </div>
          </div>

          <div
            className="grid"
            style={{
              width: "100%",
              height: "80%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ExcelGrid
              id={"items"}
              height={600}
              childRef={itemGridRef}
              cols={itemsColumn}
              rows={itemsRow}
              exportOption={false}
              newRowOption={false}
              getDefaultNewRow={getDeaultItemRow}
            />
          </div>

          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageRecord}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Game);
